import React, {useEffect, useState} from 'react';
import {observer} from 'mobx-react';
import {useServices} from "../../react-hooks/use-services.hook";
import {LoadingDotsComponent} from "../../basic-components/loading-dots/loading-dots.component";
import {IReactionDisposer, reaction} from "mobx";
import {RichPageBox} from "./boxes/rich-page.box";

export const RichPageComponent: React.FC = observer(() => {
    const services = useServices();
    const [content, setContent] = useState<React.ReactElement | null>(null);

    useEffect(() => {
        let disposeLogoutReaction: IReactionDisposer| null = null;
        if(services.user.isAuthorized) {
            services.externalLinks.then(externalLinks => {
                externalLinks.renderRichPageContent().then(c => {
                    setContent(c);
                });
            })


            disposeLogoutReaction = reaction(() => services.user.isAuthorized,
                async (isAuthorized) => {
                    // On logout if the user is in the RICH page we redirect him to the home page
                    if(!isAuthorized) {
                        await services.location.goHome();
                    }
                });
        } else {
            setContent(null);
        }

        return () => {
            if(disposeLogoutReaction) {
                disposeLogoutReaction();
            }
        }
    }, [services.user.isAuthorized, services.externalLinks, services.location]);

    if(!services.user.isAuthorized) {
        return (
            <RichPageBox>
                {services.translation.translate('RICH_USER_NOT_LOGGED_IN')}
            </RichPageBox>
        );
    }

    if(content) {
        return (
            <RichPageBox>
                {content}
            </RichPageBox>
        );
    } else {
        return (
            <LoadingDotsComponent/>
        );
    }


});